{
    "NAME": "Liste de gestion des journauxLangue",
    "LogManagementList_Column_Name": "Fichier journal",
    "LogManagementList_Column_ClassName": "Pour la classe",
    "LogManagementList_Column_FileName": "Nom de fichier",
    "LogManagementList_Column_FileSize": "Taille du fichier",
    "LogManagementList_Column_Status": "Statut",
    "LogManagementList_Status_Running": "En cours d'exécution",
    "LogManagementList_Status_NotRunning": "Ne fonctionne pas",
    "LogManagementList_Action_Start": "Commencer",
    "LogManagementList_Action_Stop": "Arrêt",
    "LogManagementList_Action_Reset": "Réinitialiser",
    "LogManagementList_Action_Download": "Télécharger",
    "LogManagementList_SearchPlaceholder": "[Fichier journal]",
    "LogManagementList_Empty": "Aucun élément de journalisation n'est actuellement affiché, ce qui indique probablement un problème critique d'initialisation d'une application ou d'un composant interne.",
    "LogManagementList_Confirm_ResetTitle": "Réinitialiser les fichiers journaux",
    "LogManagementList_Confirm_ResetBody": "Avertissement : le choix de réinitialiser les éléments du fichier journal supprimera le ou les fichiers correspondants, ce qui est une opération irréversible.",
    "LogManagementList_Confirm_StopTitle": "Arrêter la journalisation",
    "LogManagementList_Confirm_StopBody": "Le choix d'interrompre temporairement l'enregistrement des données dans les fichiers journaux sélectionnés ne doit être effectué que lorsque vous devez figer les fichiers correspondants dans des situations particulières.",
    "LogManagementList_Confirm_Generic": "Êtes-vous sûr de vouloir continuer et effectuer l'action sélectionnée ?"
}